import { Component, input, output, SimpleChanges } from '@angular/core';
import { SelectionState } from 'src/app/services/global/global-interfaces';

const multiSelectButtonActions = ['selectPage', 'deselectPage', 'deselectAll'] as const; // potentially add 'selectAll'
export type MultiSelectButtonAction = (typeof multiSelectButtonActions)[number];

@Component({
  selector: 'sb-comp-table-multi-select-button',
  templateUrl: './table-multi-select-button.component.html',
  styleUrl: './table-multi-select-button.component.scss',
  standalone: false,
})
export class TableMultiSelectButtonComponent {
  selectionState = input.required<SelectionState>();
  action = output<MultiSelectButtonAction>();

  ngChanges(changes: SimpleChanges) {
    console.log(changes);
  }
}
